/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export interface AggregatingFiguresDto {
    'outstandingAmount'?: number;
    'repaidAmount'?: number;
    'repaidPercentage'?: number;
}
export interface AggregatingFiguresExternalDto {
    'outstandingAmount'?: number;
    'repaidAmount'?: number;
    'repaidPercentage'?: number;
}
export interface ApproveLoanApplicationExternalRequest {
    'finalOffer': CreateFinalOfferRequest;
}
export interface ApproveLoanApplicationRequest {
    'finalOffer': CreateFinalOfferRequest;
}
export interface AssignLoanApplicationRequest {
    'productId': string;
}
export interface BulkRetryIncidentsResponse {
    'attemptToRetryQty'?: number;
}
export interface CreateFinalOfferRequest {
    'adminFeeAmount': number;
    'adminFeeRatePct': number;
    'adminFeeWithVatAmount': number;
    'agreementNumber': string;
    'collectionCommissionPct'?: number;
    'deductionRatePct'?: number;
    'disbursementAmount': number;
    'finalSettlementDate': string;
    'financingAmount': number;
    'firstPaymentDate': string;
    'holdbackRatePct'?: number;
    'iban': string;
    'installmentAmount'?: number;
    'installmentOption': CreateFinalOfferRequestInstallmentOptionEnum;
    'maxInstallmentAmount'?: number;
    'minInstallmentAmount'?: number;
    'murabahaRatePct': number;
    'name': string;
    'paymentFrequency': CreateFinalOfferRequestPaymentFrequencyEnum;
    'term': number;
    'totalMurabahaAmount'?: number;
    'totalRepayableAmount': number;
}

export const CreateFinalOfferRequestInstallmentOptionEnum = {
    FixedValue: 'FIXED_VALUE',
    Percentage: 'PERCENTAGE'
} as const;

export type CreateFinalOfferRequestInstallmentOptionEnum = typeof CreateFinalOfferRequestInstallmentOptionEnum[keyof typeof CreateFinalOfferRequestInstallmentOptionEnum];
export const CreateFinalOfferRequestPaymentFrequencyEnum = {
    Daily: 'DAILY',
    Weekly: 'WEEKLY',
    BiWeekly: 'BI_WEEKLY',
    Monthly: 'MONTHLY'
} as const;

export type CreateFinalOfferRequestPaymentFrequencyEnum = typeof CreateFinalOfferRequestPaymentFrequencyEnum[keyof typeof CreateFinalOfferRequestPaymentFrequencyEnum];

export interface CreatePartnerRequest {
    'arabicName': string;
    'contact': PartnerContact;
    'country': string;
    'crNumber': string;
    'description'?: string;
    'englishName'?: string;
    'erpCode'?: string;
    'jahezComissionAmount'?: number;
    'jahezComissionPct'?: number;
    'jahezComissionType': string;
    'licenseNumber'?: string;
    'partnerType': string;
    'products': Array<CreateProductRequest>;
    'specialization': Array<string>;
}
export interface CreateProductRequest {
    'description'?: string;
    'maxAmount': number;
    'maxMurabahaRatePct': number;
    'maxTerms': number;
    'minAmount': number;
    'minMurabahaRatePct': number;
    'minTerms': number;
    'name': string;
    'offeringTypes': Array<string>;
    'partnerSystemLink'?: string;
}
export interface DeclineInfoDto {
    'declineBy'?: string;
    'declineReason'?: string;
    'declinedAt'?: string;
}
export interface DeclineLoanApplicationExternalRequest {
    'reason': string;
}
export interface DeclineLoanApplicationRequest {
    'reason': string;
}
export interface DeploymentRepresentation {
    'deploymentTime': string;
    'id': string;
    'name': string;
    'source': string;
    'tenantId'?: string;
}
export interface FinalDeclineLoanApplicationRequest {
    'reason': string;
}
export interface FinalOfferDto {
    'adminFeeAmount'?: number;
    'adminFeeRatePct'?: number;
    'adminFeeWithVatAmount'?: number;
    'agreementNumber'?: string;
    'collectionCommissionPct'?: number;
    'deductionRatePct'?: number;
    'disbursementAmount'?: number;
    'finalSettlementDate'?: string;
    'financingAmount'?: number;
    'firstPaymentDate'?: string;
    'holdbackRatePct'?: number;
    'iban'?: string;
    'installmentAmount'?: number;
    'installmentOption'?: string;
    'maxInstallmentAmount'?: number;
    'minInstallmentAmount'?: number;
    'murabahaRatePct'?: number;
    'name'?: string;
    'paymentFrequency'?: string;
    'term'?: number;
    'totalMurabahaAmount'?: number;
    'totalRepayableAmount'?: number;
}
export interface FinalOfferExternalDto {
    'adminFeeAmount'?: number;
    'adminFeeRatePct'?: number;
    'adminFeeWithVatAmount'?: number;
    'agreementNumber'?: string;
    'collectionCommissionPct'?: number;
    'deductionRatePct'?: number;
    'disbursementAmount'?: number;
    'finalSettlementDate'?: string;
    'financingAmount'?: number;
    'firstPaymentDate'?: string;
    'holdbackRatePct'?: number;
    'iban'?: string;
    'installmentAmount'?: number;
    'installmentOption'?: string;
    'maxInstallmentAmount'?: number;
    'minInstallmentAmount'?: number;
    'murabahaRatePct'?: number;
    'name'?: string;
    'paymentFrequency'?: string;
    'term'?: number;
    'totalMurabahaAmount'?: number;
    'totalRepayableAmount'?: number;
}
export interface ImportError {
    'errorMessage'?: string;
    'rowNumber'?: number;
}
export interface InitialOfferDto {
    'cardArabic'?: string;
    'cardEnglish'?: string;
    'name'?: string;
    'type'?: string;
}
export interface InitialOfferExternalDto {
    'cardArabic'?: string;
    'cardEnglish'?: string;
    'name'?: string;
    'type'?: string;
}
export interface LoanApplication {
    'id'?: string;
}
export interface LoanApplicationDto {
    'active'?: boolean;
    'aggregatingFigures'?: AggregatingFiguresDto;
    'assignedAt'?: string;
    'assignedPartner'?: PartnerDto;
    'createdAt'?: string;
    'declineInfo'?: Array<DeclineInfoDto>;
    'finalDeclineAt'?: string;
    'finalDeclineBy'?: string;
    'finalDeclineReason'?: string;
    'finalOffer'?: FinalOfferDto;
    'id'?: string;
    'initialOffer'?: InitialOfferDto;
    'merchant'?: LoanApplicationMerchantDto;
    'number'?: string;
    'offerName'?: string;
    'phoneNumber'?: string;
    'product'?: ProductDto;
    'secretKey'?: string;
    'status'?: string;
}
export interface LoanApplicationExternalDto {
    'active'?: boolean;
    'aggregatingFigures'?: AggregatingFiguresExternalDto;
    'assignedAt'?: string;
    'createdAt'?: string;
    'finalOffer'?: FinalOfferExternalDto;
    'id'?: string;
    'initialOffer'?: InitialOfferExternalDto;
    'merchant'?: MerchantExternalDto;
    'number'?: string;
    'offerName'?: string;
    'phoneNumber'?: string;
    'product'?: ProductExternalDto;
    'secretKey'?: string;
    'status'?: string;
}
export interface LoanApplicationMerchantDto {
    'externalMerchantId'?: string;
    'id'?: string;
    'name'?: string;
    'number'?: string;
}
export interface MerchantDto {
    'createdAt'?: string;
    'externalMerchantId'?: string;
    'id'?: string;
    'joiningDate'?: string;
    'lastOrderDate'?: string;
    'loanApplications'?: Array<LoanApplicationDto>;
    'metrics'?: Metrics;
    'name'?: string;
    'number'?: string;
    'phoneNumbers'?: Set<string>;
    'sales'?: Array<Sales>;
    'tenureDays'?: number;
    'totalBranches'?: number;
}
export interface MerchantExternalDto {
    'createdAt'?: string;
    'id'?: string;
    'jahezMerchantId'?: string;
    'joiningDate'?: string;
    'lastOrderDate'?: string;
    'metrics'?: MetricsExternal;
    'name'?: string;
    'number'?: string;
    'sales'?: Array<SalesExternal>;
    'tenureDays'?: number;
    'totalBranches'?: number;
}
export interface MerchantSnapshotDto {
    'createdAt'?: string;
    'date'?: string;
    'id'?: string;
    'merchant'?: MerchantDto;
}
export interface MerchantSnapshotExternalDto {
    'createdAt'?: string;
    'date'?: string;
    'id'?: string;
    'merchant'?: MerchantExternalDto;
}
export interface Metrics {
    'aov'?: number;
    'oneTimeSharePct'?: number;
    'repeatSharePct'?: number;
    'totalAmount'?: number;
    'totalCustomers'?: number;
    'totalOrders'?: number;
}
export interface MetricsExternal {
    'aov'?: number;
    'oneTimeSharePct'?: number;
    'repeatSharePct'?: number;
    'totalAmount'?: number;
    'totalCustomers'?: number;
    'totalOrders'?: number;
}
export interface PageLoanApplicationDto {
    'content'?: Array<LoanApplicationDto>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObject;
    'size'?: number;
    'sort'?: SortObject;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageLoanApplicationExternalDto {
    'content'?: Array<LoanApplicationExternalDto>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObject;
    'size'?: number;
    'sort'?: SortObject;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageMerchantDto {
    'content'?: Array<MerchantDto>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObject;
    'size'?: number;
    'sort'?: SortObject;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageMerchantSnapshotExternalDto {
    'content'?: Array<MerchantSnapshotExternalDto>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObject;
    'size'?: number;
    'sort'?: SortObject;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PagePartnerDto {
    'content'?: Array<PartnerDto>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObject;
    'size'?: number;
    'sort'?: SortObject;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageTaskRepresentation {
    'content'?: Array<TaskRepresentation>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObject;
    'size'?: number;
    'sort'?: SortObject;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageTransactionDto {
    'content'?: Array<TransactionDto>;
    'empty'?: boolean;
    'first'?: boolean;
    'last'?: boolean;
    'number'?: number;
    'numberOfElements'?: number;
    'pageable'?: PageableObject;
    'size'?: number;
    'sort'?: SortObject;
    'totalElements'?: number;
    'totalPages'?: number;
}
export interface PageableObject {
    'offset'?: number;
    'pageNumber'?: number;
    'pageSize'?: number;
    'paged'?: boolean;
    'sort'?: SortObject;
    'unpaged'?: boolean;
}
export interface ParsedTransactionData {
    'rowNumber'?: number;
    'transaction'?: Transaction;
}
export interface PartnerContact {
    'contactPersonInfo': string;
    'supportEmail': string;
    'supportPhone': string;
}
export interface PartnerDto {
    'arabicName'?: string;
    'contact'?: PartnerContact;
    'country'?: string;
    'crNumber'?: string;
    'createdAt'?: string;
    'description'?: string;
    'englishName'?: string;
    'erpCode'?: string;
    'id'?: string;
    'jahezComissionAmount'?: number;
    'jahezComissionPct'?: number;
    'jahezComissionType'?: string;
    'licenseNumber'?: string;
    'number'?: string;
    'partnerType'?: string;
    'products'?: Array<ProductDto>;
    'specialization'?: Array<string>;
}
export interface ProcessDefinitionRepresentation {
    'category'?: string;
    'deploymentId': string;
    'description'?: string;
    'diagram': string;
    'extensions'?: { [key: string]: any; };
    'historyTimeToLive'?: number;
    'id': string;
    'key': string;
    'name': string;
    'resource'?: string;
    'startFormKey'?: string;
    'startableInTasklist'?: boolean;
    'suspended': boolean;
    'tenantId'?: string;
    'version'?: number;
    'versionTag'?: string;
}
export interface ProductDto {
    'description'?: string;
    'id'?: string;
    'maxAmount'?: number;
    'maxMurabahaRatePct'?: number;
    'maxTerms'?: number;
    'minAmount'?: number;
    'minMurabahaRatePct'?: number;
    'minTerms'?: number;
    'name'?: string;
    'number'?: string;
    'offeringTypes'?: Array<string>;
    'partnerSystemLink'?: string;
}
export interface ProductExternalDto {
    'id'?: string;
    'name'?: string;
    'number'?: string;
}
export interface Sales {
    'aov'?: number;
    'oneTimeSharePct'?: number;
    'periodEnd'?: string;
    'periodStart'?: string;
    'repeatSharePct'?: number;
    'totalAmount'?: number;
    'totalCustomers'?: number;
    'totalOrders'?: number;
    'type'?: string;
}
export interface SalesExternal {
    'aov'?: number;
    'oneTimeSharePct'?: number;
    'periodEnd'?: string;
    'periodStart'?: string;
    'repeatSharePct'?: number;
    'totalAmount'?: number;
    'totalCustomers'?: number;
    'totalOrders'?: number;
    'type'?: string;
}
export interface SortObject {
    'empty'?: boolean;
    'sorted'?: boolean;
    'unsorted'?: boolean;
}
export interface TaskRepresentation {
    'assignee'?: string;
    'caseDefinitionId'?: string;
    'caseExecutionId'?: string;
    'caseInstanceId'?: string;
    'createTime': string;
    'delegationState'?: string;
    'deploymentId': string;
    'description'?: string;
    'dueDate'?: string;
    'executionId': string;
    'extensions'?: { [key: string]: any; };
    'followUpDate'?: string;
    'formKey'?: string;
    'id': string;
    'name'?: string;
    'owner'?: string;
    'parentTaskId'?: string;
    'priority'?: number;
    'processDefinitionId': string;
    'processInstanceId': string;
    'suspended': boolean;
    'taskDefinitionKey': string;
    'taskInfo'?: any;
    'tenantId'?: string;
}
export interface Transaction {
    'actualRoundAmount'?: number;
    'collectionCommissionAmount'?: number;
    'comment'?: string;
    'company'?: string;
    'createdAt'?: string;
    'date'?: string;
    'deductedAmount'?: number;
    'deductedPct'?: number;
    'grossMerchandiseVolumeAmount'?: number;
    'id'?: string;
    'invoiceNumber'?: string;
    'loanApplication'?: LoanApplication;
    'merchantErpCode'?: string;
    'movedToTheNextCollectionCycleAmount'?: number;
    'number'?: string;
    'outstandingAmountAfterDeduction'?: number;
    'outstandingAmountBeforeDeduction'?: number;
    'status'?: string;
}
export interface TransactionDto {
    'actualRoundAmount'?: number;
    'agreementNumber'?: string;
    'collectionCommissionAmount'?: number;
    'collectionCommissionPct'?: number;
    'comment'?: string;
    'company'?: string;
    'createdAt'?: string;
    'date'?: string;
    'deductedAmount'?: number;
    'deductedPct'?: number;
    'deductionRatePct'?: number;
    'externalMerchantId'?: string;
    'finalSettlementDate'?: string;
    'firstPaymentDate'?: string;
    'grossMerchandiseVolumeAmount'?: number;
    'iban'?: string;
    'id'?: string;
    'installmentOption'?: string;
    'invoiceNumber'?: string;
    'loanApplicationNumber'?: string;
    'maxInstallmentAmount'?: number;
    'merchantErpCode'?: string;
    'merchantName'?: string;
    'minInstallmentAmount'?: number;
    'movedToTheNextCollectionCycleAmount'?: number;
    'number'?: string;
    'outstandingAmountAfterDeduction'?: number;
    'outstandingAmountBeforeDeduction'?: number;
    'partnerErpCode'?: string;
    'partnerName'?: string;
    'partnerNumber'?: string;
    'paymentFrequency'?: string;
    'productName'?: string;
    'status'?: string;
    'term'?: number;
    'totalRepayableAmount'?: number;
}
export interface TransactionImportResult {
    'errorCount'?: number;
    'errors'?: Array<ImportError>;
    'parsedTransactions'?: Array<ParsedTransactionData>;
    'successCount'?: number;
    'totalRows'?: number;
}
export interface UiConfigurations {
    'appName'?: string;
    'authClientId'?: string;
    'authRealm'?: string;
    'authServerUrl'?: string;
    'borrowerType'?: string;
    'defaultLocale'?: string;
    'defaultProcessKey'?: string;
    'env'?: { [key: string]: string; };
    'supportedLocales'?: Array<string>;
}
export interface UpdatePartnerRequest {
    'arabicName': string;
    'contact': PartnerContact;
    'country': string;
    'crNumber': string;
    'description'?: string;
    'englishName'?: string;
    'erpCode'?: string;
    'jahezComissionAmount'?: number;
    'jahezComissionPct'?: number;
    'jahezComissionType': string;
    'licenseNumber'?: string;
    'partnerType': string;
    'products': Array<UpdateProductRequest>;
    'specialization': Array<string>;
}
export interface UpdateProductRequest {
    'description'?: string;
    'id'?: string;
    'maxAmount': number;
    'maxMurabahaRatePct': number;
    'maxTerms': number;
    'minAmount': number;
    'minMurabahaRatePct': number;
    'minTerms': number;
    'name': string;
    'offeringTypes': Array<string>;
    'partnerSystemLink'?: string;
}

/**
 * BPMSIncidentsManagementApi - axios parameter creator
 */
export const BPMSIncidentsManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Asynchronously increase retry count for all insidents in the system
         * @summary Bulk retry incidents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkRetryIncidents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/incident/bulk-retry`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BPMSIncidentsManagementApi - functional programming interface
 */
export const BPMSIncidentsManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BPMSIncidentsManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Asynchronously increase retry count for all insidents in the system
         * @summary Bulk retry incidents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkRetryIncidents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkRetryIncidentsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkRetryIncidents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BPMSIncidentsManagementApi.bulkRetryIncidents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BPMSIncidentsManagementApi - factory interface
 */
export const BPMSIncidentsManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BPMSIncidentsManagementApiFp(configuration)
    return {
        /**
         * Asynchronously increase retry count for all insidents in the system
         * @summary Bulk retry incidents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkRetryIncidents(options?: RawAxiosRequestConfig): AxiosPromise<BulkRetryIncidentsResponse> {
            return localVarFp.bulkRetryIncidents(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BPMSIncidentsManagementApi - object-oriented interface
 */
export class BPMSIncidentsManagementApi extends BaseAPI {
    /**
     * Asynchronously increase retry count for all insidents in the system
     * @summary Bulk retry incidents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public bulkRetryIncidents(options?: RawAxiosRequestConfig) {
        return BPMSIncidentsManagementApiFp(this.configuration).bulkRetryIncidents(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BPMSResourcesManagementApi - axios parameter creator
 */
export const BPMSResourcesManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Allowed to upload multiple resources and also packet to ZIP files. Process instances migration to new versions will be performed after deployment. All system insidents will be retried after the migration.
         * @summary Create a deployment with specified resources
         * @param {string} deploymentName Name for the deployment
         * @param {Array<File>} files Resources which the deployment will consist of
         * @param {boolean} [migrate] Migrate all process instances to new deployed versions. To perform perform migration process definitions has to comply conditions/rules explained at https://www.novatec-gmbh.de/blog/automating-process-instance-migration-with-camunda-bpm/ 
         * @param {boolean} [retryIncidents] Bulk retry all incidents in the system after deployment and migration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (deploymentName: string, files: Array<File>, migrate?: boolean, retryIncidents?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deploymentName' is not null or undefined
            assertParamExists('create', 'deploymentName', deploymentName)
            // verify required parameter 'files' is not null or undefined
            assertParamExists('create', 'files', files)
            const localVarPath = `/api/deployment/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            if (deploymentName !== undefined) {
                localVarQueryParameter['deployment-name'] = deploymentName;
            }

            if (files) {
                localVarQueryParameter['files'] = files;
            }

            if (migrate !== undefined) {
                localVarQueryParameter['migrate'] = migrate;
            }

            if (retryIncidents !== undefined) {
                localVarQueryParameter['retry-incidents'] = retryIncidents;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves a form by key from \'/public\' folder in deployment storage
         * @summary Retrieves a deployed form by key
         * @param {string} formKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForm: async (formKey: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'formKey' is not null or undefined
            assertParamExists('getForm', 'formKey', formKey)
            const localVarPath = `/api/deployment/form`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            if (formKey !== undefined) {
                localVarQueryParameter['form-key'] = formKey;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves latest version of the resource by name from \'/public\' folder from deployment
         * @summary Retrieves a public resource by name
         * @param {string} [jsonFilter] Filters JSON response utilizing JSONPath syntax if response content type is application/json. See for details: https://github.com/json-path/JsonPath#readme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestResource: async (jsonFilter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/deployment/resource/**`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            if (jsonFilter !== undefined) {
                localVarQueryParameter['jsonFilter'] = jsonFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BPMSResourcesManagementApi - functional programming interface
 */
export const BPMSResourcesManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BPMSResourcesManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Allowed to upload multiple resources and also packet to ZIP files. Process instances migration to new versions will be performed after deployment. All system insidents will be retried after the migration.
         * @summary Create a deployment with specified resources
         * @param {string} deploymentName Name for the deployment
         * @param {Array<File>} files Resources which the deployment will consist of
         * @param {boolean} [migrate] Migrate all process instances to new deployed versions. To perform perform migration process definitions has to comply conditions/rules explained at https://www.novatec-gmbh.de/blog/automating-process-instance-migration-with-camunda-bpm/ 
         * @param {boolean} [retryIncidents] Bulk retry all incidents in the system after deployment and migration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(deploymentName: string, files: Array<File>, migrate?: boolean, retryIncidents?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeploymentRepresentation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(deploymentName, files, migrate, retryIncidents, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BPMSResourcesManagementApi.create']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves a form by key from \'/public\' folder in deployment storage
         * @summary Retrieves a deployed form by key
         * @param {string} formKey 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForm(formKey: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getForm(formKey, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BPMSResourcesManagementApi.getForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves latest version of the resource by name from \'/public\' folder from deployment
         * @summary Retrieves a public resource by name
         * @param {string} [jsonFilter] Filters JSON response utilizing JSONPath syntax if response content type is application/json. See for details: https://github.com/json-path/JsonPath#readme
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestResource(jsonFilter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestResource(jsonFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BPMSResourcesManagementApi.getLatestResource']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BPMSResourcesManagementApi - factory interface
 */
export const BPMSResourcesManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BPMSResourcesManagementApiFp(configuration)
    return {
        /**
         * Allowed to upload multiple resources and also packet to ZIP files. Process instances migration to new versions will be performed after deployment. All system insidents will be retried after the migration.
         * @summary Create a deployment with specified resources
         * @param {BPMSResourcesManagementApiCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(requestParameters: BPMSResourcesManagementApiCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeploymentRepresentation> {
            return localVarFp.create(requestParameters.deploymentName, requestParameters.files, requestParameters.migrate, requestParameters.retryIncidents, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves a form by key from \'/public\' folder in deployment storage
         * @summary Retrieves a deployed form by key
         * @param {BPMSResourcesManagementApiGetFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForm(requestParameters: BPMSResourcesManagementApiGetFormRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getForm(requestParameters.formKey, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves latest version of the resource by name from \'/public\' folder from deployment
         * @summary Retrieves a public resource by name
         * @param {BPMSResourcesManagementApiGetLatestResourceRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestResource(requestParameters: BPMSResourcesManagementApiGetLatestResourceRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getLatestResource(requestParameters.jsonFilter, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for create operation in BPMSResourcesManagementApi.
 */
export interface BPMSResourcesManagementApiCreateRequest {
    /**
     * Name for the deployment
     */
    readonly deploymentName: string

    /**
     * Resources which the deployment will consist of
     */
    readonly files: Array<File>

    /**
     * Migrate all process instances to new deployed versions. To perform perform migration process definitions has to comply conditions/rules explained at https://www.novatec-gmbh.de/blog/automating-process-instance-migration-with-camunda-bpm/ 
     */
    readonly migrate?: boolean

    /**
     * Bulk retry all incidents in the system after deployment and migration
     */
    readonly retryIncidents?: boolean
}

/**
 * Request parameters for getForm operation in BPMSResourcesManagementApi.
 */
export interface BPMSResourcesManagementApiGetFormRequest {
    readonly formKey: string
}

/**
 * Request parameters for getLatestResource operation in BPMSResourcesManagementApi.
 */
export interface BPMSResourcesManagementApiGetLatestResourceRequest {
    /**
     * Filters JSON response utilizing JSONPath syntax if response content type is application/json. See for details: https://github.com/json-path/JsonPath#readme
     */
    readonly jsonFilter?: string
}

/**
 * BPMSResourcesManagementApi - object-oriented interface
 */
export class BPMSResourcesManagementApi extends BaseAPI {
    /**
     * Allowed to upload multiple resources and also packet to ZIP files. Process instances migration to new versions will be performed after deployment. All system insidents will be retried after the migration.
     * @summary Create a deployment with specified resources
     * @param {BPMSResourcesManagementApiCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public create(requestParameters: BPMSResourcesManagementApiCreateRequest, options?: RawAxiosRequestConfig) {
        return BPMSResourcesManagementApiFp(this.configuration).create(requestParameters.deploymentName, requestParameters.files, requestParameters.migrate, requestParameters.retryIncidents, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves a form by key from \'/public\' folder in deployment storage
     * @summary Retrieves a deployed form by key
     * @param {BPMSResourcesManagementApiGetFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getForm(requestParameters: BPMSResourcesManagementApiGetFormRequest, options?: RawAxiosRequestConfig) {
        return BPMSResourcesManagementApiFp(this.configuration).getForm(requestParameters.formKey, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves latest version of the resource by name from \'/public\' folder from deployment
     * @summary Retrieves a public resource by name
     * @param {BPMSResourcesManagementApiGetLatestResourceRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLatestResource(requestParameters: BPMSResourcesManagementApiGetLatestResourceRequest = {}, options?: RawAxiosRequestConfig) {
        return BPMSResourcesManagementApiFp(this.configuration).getLatestResource(requestParameters.jsonFilter, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ExternalApi - axios parameter creator
 */
export const ExternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Approve loan application
         * @param {string} id 
         * @param {ApproveLoanApplicationExternalRequest} approveLoanApplicationExternalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveLoanApplicationForExternal: async (id: string, approveLoanApplicationExternalRequest: ApproveLoanApplicationExternalRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('approveLoanApplicationForExternal', 'id', id)
            // verify required parameter 'approveLoanApplicationExternalRequest' is not null or undefined
            assertParamExists('approveLoanApplicationForExternal', 'approveLoanApplicationExternalRequest', approveLoanApplicationExternalRequest)
            const localVarPath = `/api/external/v1/loan-applications/{id}/approve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveLoanApplicationExternalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Decline loan application
         * @param {string} id 
         * @param {DeclineLoanApplicationExternalRequest} declineLoanApplicationExternalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineLoanApplicationForExternal: async (id: string, declineLoanApplicationExternalRequest: DeclineLoanApplicationExternalRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('declineLoanApplicationForExternal', 'id', id)
            // verify required parameter 'declineLoanApplicationExternalRequest' is not null or undefined
            assertParamExists('declineLoanApplicationForExternal', 'declineLoanApplicationExternalRequest', declineLoanApplicationExternalRequest)
            const localVarPath = `/api/external/v1/loan-applications/{id}/decline`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(declineLoanApplicationExternalRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of loan applications
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Filter by loan application statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllLoanApplicationsForExternal: async (page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/external/v1/loan-applications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterStatuses) {
                localVarQueryParameter['filter.statuses'] = filterStatuses;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get loan application by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanApplicationForExternal: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLoanApplicationForExternal', 'id', id)
            const localVarPath = `/api/external/v1/loan-applications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of merchant snapshots for loan application
         * @param {string} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [filterDateFrom] Filter by date from
         * @param {string} [filterDateTo] Filter by date to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantSnapshotsForLoanApplication: async (id: string, page?: number, size?: number, sort?: Array<string>, filterDateFrom?: string, filterDateTo?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMerchantSnapshotsForLoanApplication', 'id', id)
            const localVarPath = `/api/external/v1/loan-applications/{id}/merchant-snapshots`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterDateFrom !== undefined) {
                localVarQueryParameter['filter.dateFrom'] = (filterDateFrom as any instanceof Date) ?
                    (filterDateFrom as any).toISOString() :
                    filterDateFrom;
            }

            if (filterDateTo !== undefined) {
                localVarQueryParameter['filter.dateTo'] = (filterDateTo as any instanceof Date) ?
                    (filterDateTo as any).toISOString() :
                    filterDateTo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ExternalApi - functional programming interface
 */
export const ExternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ExternalApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Approve loan application
         * @param {string} id 
         * @param {ApproveLoanApplicationExternalRequest} approveLoanApplicationExternalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveLoanApplicationForExternal(id: string, approveLoanApplicationExternalRequest: ApproveLoanApplicationExternalRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationExternalDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveLoanApplicationForExternal(id, approveLoanApplicationExternalRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalApi.approveLoanApplicationForExternal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Decline loan application
         * @param {string} id 
         * @param {DeclineLoanApplicationExternalRequest} declineLoanApplicationExternalRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declineLoanApplicationForExternal(id: string, declineLoanApplicationExternalRequest: DeclineLoanApplicationExternalRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationExternalDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declineLoanApplicationForExternal(id, declineLoanApplicationExternalRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalApi.declineLoanApplicationForExternal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of loan applications
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Filter by loan application statuses
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllLoanApplicationsForExternal(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanApplicationExternalDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllLoanApplicationsForExternal(page, size, sort, filterStatuses, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalApi.findAllLoanApplicationsForExternal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get loan application by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoanApplicationForExternal(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationExternalDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoanApplicationForExternal(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalApi.getLoanApplicationForExternal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of merchant snapshots for loan application
         * @param {string} id 
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [filterDateFrom] Filter by date from
         * @param {string} [filterDateTo] Filter by date to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantSnapshotsForLoanApplication(id: string, page?: number, size?: number, sort?: Array<string>, filterDateFrom?: string, filterDateTo?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageMerchantSnapshotExternalDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantSnapshotsForLoanApplication(id, page, size, sort, filterDateFrom, filterDateTo, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ExternalApi.getMerchantSnapshotsForLoanApplication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ExternalApi - factory interface
 */
export const ExternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ExternalApiFp(configuration)
    return {
        /**
         * 
         * @summary Approve loan application
         * @param {ExternalApiApproveLoanApplicationForExternalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveLoanApplicationForExternal(requestParameters: ExternalApiApproveLoanApplicationForExternalRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoanApplicationExternalDto> {
            return localVarFp.approveLoanApplicationForExternal(requestParameters.id, requestParameters.approveLoanApplicationExternalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Decline loan application
         * @param {ExternalApiDeclineLoanApplicationForExternalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineLoanApplicationForExternal(requestParameters: ExternalApiDeclineLoanApplicationForExternalRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoanApplicationExternalDto> {
            return localVarFp.declineLoanApplicationForExternal(requestParameters.id, requestParameters.declineLoanApplicationExternalRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of loan applications
         * @param {ExternalApiFindAllLoanApplicationsForExternalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllLoanApplicationsForExternal(requestParameters: ExternalApiFindAllLoanApplicationsForExternalRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageLoanApplicationExternalDto> {
            return localVarFp.findAllLoanApplicationsForExternal(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterStatuses, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get loan application by ID
         * @param {ExternalApiGetLoanApplicationForExternalRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanApplicationForExternal(requestParameters: ExternalApiGetLoanApplicationForExternalRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoanApplicationExternalDto> {
            return localVarFp.getLoanApplicationForExternal(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of merchant snapshots for loan application
         * @param {ExternalApiGetMerchantSnapshotsForLoanApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantSnapshotsForLoanApplication(requestParameters: ExternalApiGetMerchantSnapshotsForLoanApplicationRequest, options?: RawAxiosRequestConfig): AxiosPromise<PageMerchantSnapshotExternalDto> {
            return localVarFp.getMerchantSnapshotsForLoanApplication(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterDateFrom, requestParameters.filterDateTo, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for approveLoanApplicationForExternal operation in ExternalApi.
 */
export interface ExternalApiApproveLoanApplicationForExternalRequest {
    readonly id: string

    readonly approveLoanApplicationExternalRequest: ApproveLoanApplicationExternalRequest
}

/**
 * Request parameters for declineLoanApplicationForExternal operation in ExternalApi.
 */
export interface ExternalApiDeclineLoanApplicationForExternalRequest {
    readonly id: string

    readonly declineLoanApplicationExternalRequest: DeclineLoanApplicationExternalRequest
}

/**
 * Request parameters for findAllLoanApplicationsForExternal operation in ExternalApi.
 */
export interface ExternalApiFindAllLoanApplicationsForExternalRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>

    /**
     * Filter by loan application statuses
     */
    readonly filterStatuses?: Array<string>
}

/**
 * Request parameters for getLoanApplicationForExternal operation in ExternalApi.
 */
export interface ExternalApiGetLoanApplicationForExternalRequest {
    readonly id: string
}

/**
 * Request parameters for getMerchantSnapshotsForLoanApplication operation in ExternalApi.
 */
export interface ExternalApiGetMerchantSnapshotsForLoanApplicationRequest {
    readonly id: string

    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>

    /**
     * Filter by date from
     */
    readonly filterDateFrom?: string

    /**
     * Filter by date to
     */
    readonly filterDateTo?: string
}

/**
 * ExternalApi - object-oriented interface
 */
export class ExternalApi extends BaseAPI {
    /**
     * 
     * @summary Approve loan application
     * @param {ExternalApiApproveLoanApplicationForExternalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public approveLoanApplicationForExternal(requestParameters: ExternalApiApproveLoanApplicationForExternalRequest, options?: RawAxiosRequestConfig) {
        return ExternalApiFp(this.configuration).approveLoanApplicationForExternal(requestParameters.id, requestParameters.approveLoanApplicationExternalRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Decline loan application
     * @param {ExternalApiDeclineLoanApplicationForExternalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public declineLoanApplicationForExternal(requestParameters: ExternalApiDeclineLoanApplicationForExternalRequest, options?: RawAxiosRequestConfig) {
        return ExternalApiFp(this.configuration).declineLoanApplicationForExternal(requestParameters.id, requestParameters.declineLoanApplicationExternalRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of loan applications
     * @param {ExternalApiFindAllLoanApplicationsForExternalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllLoanApplicationsForExternal(requestParameters: ExternalApiFindAllLoanApplicationsForExternalRequest = {}, options?: RawAxiosRequestConfig) {
        return ExternalApiFp(this.configuration).findAllLoanApplicationsForExternal(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterStatuses, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get loan application by ID
     * @param {ExternalApiGetLoanApplicationForExternalRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLoanApplicationForExternal(requestParameters: ExternalApiGetLoanApplicationForExternalRequest, options?: RawAxiosRequestConfig) {
        return ExternalApiFp(this.configuration).getLoanApplicationForExternal(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of merchant snapshots for loan application
     * @param {ExternalApiGetMerchantSnapshotsForLoanApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMerchantSnapshotsForLoanApplication(requestParameters: ExternalApiGetMerchantSnapshotsForLoanApplicationRequest, options?: RawAxiosRequestConfig) {
        return ExternalApiFp(this.configuration).getMerchantSnapshotsForLoanApplication(requestParameters.id, requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterDateFrom, requestParameters.filterDateTo, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LoanApplicationAgentAPIApi - axios parameter creator
 */
export const LoanApplicationAgentAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Approve loan application
         * @param {string} id 
         * @param {ApproveLoanApplicationRequest} approveLoanApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveLoanApplicationForAgent: async (id: string, approveLoanApplicationRequest: ApproveLoanApplicationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('approveLoanApplicationForAgent', 'id', id)
            // verify required parameter 'approveLoanApplicationRequest' is not null or undefined
            assertParamExists('approveLoanApplicationForAgent', 'approveLoanApplicationRequest', approveLoanApplicationRequest)
            const localVarPath = `/api/agent/loan-applications/{id}/approve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(approveLoanApplicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Decline loan application
         * @param {string} id 
         * @param {DeclineLoanApplicationRequest} declineLoanApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineLoanApplicationForAgent: async (id: string, declineLoanApplicationRequest: DeclineLoanApplicationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('declineLoanApplicationForAgent', 'id', id)
            // verify required parameter 'declineLoanApplicationRequest' is not null or undefined
            assertParamExists('declineLoanApplicationForAgent', 'declineLoanApplicationRequest', declineLoanApplicationRequest)
            const localVarPath = `/api/agent/loan-applications/{id}/decline`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(declineLoanApplicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of loan applications for agent
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Filter by loan application statuses
         * @param {string} [filterPartnerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllLoanApplicationsForAgent: async (page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterPartnerId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/agent/loan-applications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterStatuses) {
                localVarQueryParameter['filter.statuses'] = filterStatuses;
            }

            if (filterPartnerId !== undefined) {
                localVarQueryParameter['filter.partnerId'] = filterPartnerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return agent\'s single loan application
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanApplicationForAgent: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLoanApplicationForAgent', 'id', id)
            const localVarPath = `/api/agent/loan-applications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get merchant snapshots for loan application
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantSnapshotsForAgent: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMerchantSnapshotsForAgent', 'id', id)
            const localVarPath = `/api/agent/loan-applications/{id}/merchant-snapshots`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get transactions for loan application
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsForAgent: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTransactionsForAgent', 'id', id)
            const localVarPath = `/api/agent/loan-applications/{id}/transactions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanApplicationAgentAPIApi - functional programming interface
 */
export const LoanApplicationAgentAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoanApplicationAgentAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Approve loan application
         * @param {string} id 
         * @param {ApproveLoanApplicationRequest} approveLoanApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async approveLoanApplicationForAgent(id: string, approveLoanApplicationRequest: ApproveLoanApplicationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.approveLoanApplicationForAgent(id, approveLoanApplicationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApplicationAgentAPIApi.approveLoanApplicationForAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Decline loan application
         * @param {string} id 
         * @param {DeclineLoanApplicationRequest} declineLoanApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declineLoanApplicationForAgent(id: string, declineLoanApplicationRequest: DeclineLoanApplicationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declineLoanApplicationForAgent(id, declineLoanApplicationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApplicationAgentAPIApi.declineLoanApplicationForAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of loan applications for agent
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Filter by loan application statuses
         * @param {string} [filterPartnerId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllLoanApplicationsForAgent(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterPartnerId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanApplicationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllLoanApplicationsForAgent(page, size, sort, filterStatuses, filterPartnerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApplicationAgentAPIApi.findAllLoanApplicationsForAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return agent\'s single loan application
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoanApplicationForAgent(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoanApplicationForAgent(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApplicationAgentAPIApi.getLoanApplicationForAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get merchant snapshots for loan application
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantSnapshotsForAgent(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MerchantSnapshotDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantSnapshotsForAgent(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApplicationAgentAPIApi.getMerchantSnapshotsForAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get transactions for loan application
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionsForAgent(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransactionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionsForAgent(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApplicationAgentAPIApi.getTransactionsForAgent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LoanApplicationAgentAPIApi - factory interface
 */
export const LoanApplicationAgentAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoanApplicationAgentAPIApiFp(configuration)
    return {
        /**
         * 
         * @summary Approve loan application
         * @param {LoanApplicationAgentAPIApiApproveLoanApplicationForAgentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        approveLoanApplicationForAgent(requestParameters: LoanApplicationAgentAPIApiApproveLoanApplicationForAgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoanApplicationDto> {
            return localVarFp.approveLoanApplicationForAgent(requestParameters.id, requestParameters.approveLoanApplicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Decline loan application
         * @param {LoanApplicationAgentAPIApiDeclineLoanApplicationForAgentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineLoanApplicationForAgent(requestParameters: LoanApplicationAgentAPIApiDeclineLoanApplicationForAgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoanApplicationDto> {
            return localVarFp.declineLoanApplicationForAgent(requestParameters.id, requestParameters.declineLoanApplicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of loan applications for agent
         * @param {LoanApplicationAgentAPIApiFindAllLoanApplicationsForAgentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllLoanApplicationsForAgent(requestParameters: LoanApplicationAgentAPIApiFindAllLoanApplicationsForAgentRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageLoanApplicationDto> {
            return localVarFp.findAllLoanApplicationsForAgent(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterStatuses, requestParameters.filterPartnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return agent\'s single loan application
         * @param {LoanApplicationAgentAPIApiGetLoanApplicationForAgentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanApplicationForAgent(requestParameters: LoanApplicationAgentAPIApiGetLoanApplicationForAgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoanApplicationDto> {
            return localVarFp.getLoanApplicationForAgent(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get merchant snapshots for loan application
         * @param {LoanApplicationAgentAPIApiGetMerchantSnapshotsForAgentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantSnapshotsForAgent(requestParameters: LoanApplicationAgentAPIApiGetMerchantSnapshotsForAgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<MerchantSnapshotDto>> {
            return localVarFp.getMerchantSnapshotsForAgent(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get transactions for loan application
         * @param {LoanApplicationAgentAPIApiGetTransactionsForAgentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsForAgent(requestParameters: LoanApplicationAgentAPIApiGetTransactionsForAgentRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TransactionDto>> {
            return localVarFp.getTransactionsForAgent(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for approveLoanApplicationForAgent operation in LoanApplicationAgentAPIApi.
 */
export interface LoanApplicationAgentAPIApiApproveLoanApplicationForAgentRequest {
    readonly id: string

    readonly approveLoanApplicationRequest: ApproveLoanApplicationRequest
}

/**
 * Request parameters for declineLoanApplicationForAgent operation in LoanApplicationAgentAPIApi.
 */
export interface LoanApplicationAgentAPIApiDeclineLoanApplicationForAgentRequest {
    readonly id: string

    readonly declineLoanApplicationRequest: DeclineLoanApplicationRequest
}

/**
 * Request parameters for findAllLoanApplicationsForAgent operation in LoanApplicationAgentAPIApi.
 */
export interface LoanApplicationAgentAPIApiFindAllLoanApplicationsForAgentRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>

    /**
     * Filter by loan application statuses
     */
    readonly filterStatuses?: Array<string>

    readonly filterPartnerId?: string
}

/**
 * Request parameters for getLoanApplicationForAgent operation in LoanApplicationAgentAPIApi.
 */
export interface LoanApplicationAgentAPIApiGetLoanApplicationForAgentRequest {
    readonly id: string
}

/**
 * Request parameters for getMerchantSnapshotsForAgent operation in LoanApplicationAgentAPIApi.
 */
export interface LoanApplicationAgentAPIApiGetMerchantSnapshotsForAgentRequest {
    readonly id: string
}

/**
 * Request parameters for getTransactionsForAgent operation in LoanApplicationAgentAPIApi.
 */
export interface LoanApplicationAgentAPIApiGetTransactionsForAgentRequest {
    readonly id: string
}

/**
 * LoanApplicationAgentAPIApi - object-oriented interface
 */
export class LoanApplicationAgentAPIApi extends BaseAPI {
    /**
     * 
     * @summary Approve loan application
     * @param {LoanApplicationAgentAPIApiApproveLoanApplicationForAgentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public approveLoanApplicationForAgent(requestParameters: LoanApplicationAgentAPIApiApproveLoanApplicationForAgentRequest, options?: RawAxiosRequestConfig) {
        return LoanApplicationAgentAPIApiFp(this.configuration).approveLoanApplicationForAgent(requestParameters.id, requestParameters.approveLoanApplicationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Decline loan application
     * @param {LoanApplicationAgentAPIApiDeclineLoanApplicationForAgentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public declineLoanApplicationForAgent(requestParameters: LoanApplicationAgentAPIApiDeclineLoanApplicationForAgentRequest, options?: RawAxiosRequestConfig) {
        return LoanApplicationAgentAPIApiFp(this.configuration).declineLoanApplicationForAgent(requestParameters.id, requestParameters.declineLoanApplicationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of loan applications for agent
     * @param {LoanApplicationAgentAPIApiFindAllLoanApplicationsForAgentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllLoanApplicationsForAgent(requestParameters: LoanApplicationAgentAPIApiFindAllLoanApplicationsForAgentRequest = {}, options?: RawAxiosRequestConfig) {
        return LoanApplicationAgentAPIApiFp(this.configuration).findAllLoanApplicationsForAgent(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterStatuses, requestParameters.filterPartnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return agent\'s single loan application
     * @param {LoanApplicationAgentAPIApiGetLoanApplicationForAgentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLoanApplicationForAgent(requestParameters: LoanApplicationAgentAPIApiGetLoanApplicationForAgentRequest, options?: RawAxiosRequestConfig) {
        return LoanApplicationAgentAPIApiFp(this.configuration).getLoanApplicationForAgent(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get merchant snapshots for loan application
     * @param {LoanApplicationAgentAPIApiGetMerchantSnapshotsForAgentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMerchantSnapshotsForAgent(requestParameters: LoanApplicationAgentAPIApiGetMerchantSnapshotsForAgentRequest, options?: RawAxiosRequestConfig) {
        return LoanApplicationAgentAPIApiFp(this.configuration).getMerchantSnapshotsForAgent(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get transactions for loan application
     * @param {LoanApplicationAgentAPIApiGetTransactionsForAgentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTransactionsForAgent(requestParameters: LoanApplicationAgentAPIApiGetTransactionsForAgentRequest, options?: RawAxiosRequestConfig) {
        return LoanApplicationAgentAPIApiFp(this.configuration).getTransactionsForAgent(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LoanApplicationBackofficeAPIApi - axios parameter creator
 */
export const LoanApplicationBackofficeAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Assign loan application to product
         * @param {string} id 
         * @param {AssignLoanApplicationRequest} assignLoanApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignLoanApplicationForBackoffice: async (id: string, assignLoanApplicationRequest: AssignLoanApplicationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('assignLoanApplicationForBackoffice', 'id', id)
            // verify required parameter 'assignLoanApplicationRequest' is not null or undefined
            assertParamExists('assignLoanApplicationForBackoffice', 'assignLoanApplicationRequest', assignLoanApplicationRequest)
            const localVarPath = `/api/backoffice/loan-applications/{id}/assign`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignLoanApplicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Decline loan application
         * @param {string} id 
         * @param {FinalDeclineLoanApplicationRequest} finalDeclineLoanApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineLoanApplicationForBackoffice: async (id: string, finalDeclineLoanApplicationRequest: FinalDeclineLoanApplicationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('declineLoanApplicationForBackoffice', 'id', id)
            // verify required parameter 'finalDeclineLoanApplicationRequest' is not null or undefined
            assertParamExists('declineLoanApplicationForBackoffice', 'finalDeclineLoanApplicationRequest', finalDeclineLoanApplicationRequest)
            const localVarPath = `/api/backoffice/loan-applications/{id}/decline`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(finalDeclineLoanApplicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export active loan applications to Excel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportActiveLoanApplications: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backoffice/loan-applications/export`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of loan applications
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Filter by loan application statuses
         * @param {string} [filterPartnerId] Filter by assigned partner ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllLoanApplicationsForBackoffice: async (page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterPartnerId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backoffice/loan-applications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterStatuses) {
                localVarQueryParameter['filter.statuses'] = filterStatuses;
            }

            if (filterPartnerId !== undefined) {
                localVarQueryParameter['filter.partnerId'] = filterPartnerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get loan application by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanApplicationForBackoffice: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLoanApplicationForBackoffice', 'id', id)
            const localVarPath = `/api/backoffice/loan-applications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get merchant snapshots for loan application
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantSnapshotsForBackoffice: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMerchantSnapshotsForBackoffice', 'id', id)
            const localVarPath = `/api/backoffice/loan-applications/{id}/merchant-snapshots`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get transactions for loan application
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsForBackoffice: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTransactionsForBackoffice', 'id', id)
            const localVarPath = `/api/backoffice/loan-applications/{id}/transactions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark loan application as fully paid
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repaidLoanApplicationForBackoffice: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('repaidLoanApplicationForBackoffice', 'id', id)
            const localVarPath = `/api/backoffice/loan-applications/{id}/repaid`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanApplicationBackofficeAPIApi - functional programming interface
 */
export const LoanApplicationBackofficeAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoanApplicationBackofficeAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Assign loan application to product
         * @param {string} id 
         * @param {AssignLoanApplicationRequest} assignLoanApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assignLoanApplicationForBackoffice(id: string, assignLoanApplicationRequest: AssignLoanApplicationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assignLoanApplicationForBackoffice(id, assignLoanApplicationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApplicationBackofficeAPIApi.assignLoanApplicationForBackoffice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Decline loan application
         * @param {string} id 
         * @param {FinalDeclineLoanApplicationRequest} finalDeclineLoanApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declineLoanApplicationForBackoffice(id: string, finalDeclineLoanApplicationRequest: FinalDeclineLoanApplicationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declineLoanApplicationForBackoffice(id, finalDeclineLoanApplicationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApplicationBackofficeAPIApi.declineLoanApplicationForBackoffice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export active loan applications to Excel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportActiveLoanApplications(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportActiveLoanApplications(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApplicationBackofficeAPIApi.exportActiveLoanApplications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of loan applications
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {Array<string>} [filterStatuses] Filter by loan application statuses
         * @param {string} [filterPartnerId] Filter by assigned partner ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllLoanApplicationsForBackoffice(page?: number, size?: number, sort?: Array<string>, filterStatuses?: Array<string>, filterPartnerId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanApplicationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllLoanApplicationsForBackoffice(page, size, sort, filterStatuses, filterPartnerId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApplicationBackofficeAPIApi.findAllLoanApplicationsForBackoffice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get loan application by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoanApplicationForBackoffice(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoanApplicationForBackoffice(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApplicationBackofficeAPIApi.getLoanApplicationForBackoffice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get merchant snapshots for loan application
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantSnapshotsForBackoffice(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MerchantSnapshotDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantSnapshotsForBackoffice(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApplicationBackofficeAPIApi.getMerchantSnapshotsForBackoffice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get transactions for loan application
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionsForBackoffice(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransactionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionsForBackoffice(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApplicationBackofficeAPIApi.getTransactionsForBackoffice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark loan application as fully paid
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async repaidLoanApplicationForBackoffice(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.repaidLoanApplicationForBackoffice(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApplicationBackofficeAPIApi.repaidLoanApplicationForBackoffice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LoanApplicationBackofficeAPIApi - factory interface
 */
export const LoanApplicationBackofficeAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoanApplicationBackofficeAPIApiFp(configuration)
    return {
        /**
         * 
         * @summary Assign loan application to product
         * @param {LoanApplicationBackofficeAPIApiAssignLoanApplicationForBackofficeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assignLoanApplicationForBackoffice(requestParameters: LoanApplicationBackofficeAPIApiAssignLoanApplicationForBackofficeRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoanApplicationDto> {
            return localVarFp.assignLoanApplicationForBackoffice(requestParameters.id, requestParameters.assignLoanApplicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Decline loan application
         * @param {LoanApplicationBackofficeAPIApiDeclineLoanApplicationForBackofficeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineLoanApplicationForBackoffice(requestParameters: LoanApplicationBackofficeAPIApiDeclineLoanApplicationForBackofficeRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoanApplicationDto> {
            return localVarFp.declineLoanApplicationForBackoffice(requestParameters.id, requestParameters.finalDeclineLoanApplicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export active loan applications to Excel
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportActiveLoanApplications(options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.exportActiveLoanApplications(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of loan applications
         * @param {LoanApplicationBackofficeAPIApiFindAllLoanApplicationsForBackofficeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllLoanApplicationsForBackoffice(requestParameters: LoanApplicationBackofficeAPIApiFindAllLoanApplicationsForBackofficeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageLoanApplicationDto> {
            return localVarFp.findAllLoanApplicationsForBackoffice(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterStatuses, requestParameters.filterPartnerId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get loan application by ID
         * @param {LoanApplicationBackofficeAPIApiGetLoanApplicationForBackofficeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanApplicationForBackoffice(requestParameters: LoanApplicationBackofficeAPIApiGetLoanApplicationForBackofficeRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoanApplicationDto> {
            return localVarFp.getLoanApplicationForBackoffice(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get merchant snapshots for loan application
         * @param {LoanApplicationBackofficeAPIApiGetMerchantSnapshotsForBackofficeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantSnapshotsForBackoffice(requestParameters: LoanApplicationBackofficeAPIApiGetMerchantSnapshotsForBackofficeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<MerchantSnapshotDto>> {
            return localVarFp.getMerchantSnapshotsForBackoffice(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get transactions for loan application
         * @param {LoanApplicationBackofficeAPIApiGetTransactionsForBackofficeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsForBackoffice(requestParameters: LoanApplicationBackofficeAPIApiGetTransactionsForBackofficeRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TransactionDto>> {
            return localVarFp.getTransactionsForBackoffice(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark loan application as fully paid
         * @param {LoanApplicationBackofficeAPIApiRepaidLoanApplicationForBackofficeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        repaidLoanApplicationForBackoffice(requestParameters: LoanApplicationBackofficeAPIApiRepaidLoanApplicationForBackofficeRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoanApplicationDto> {
            return localVarFp.repaidLoanApplicationForBackoffice(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for assignLoanApplicationForBackoffice operation in LoanApplicationBackofficeAPIApi.
 */
export interface LoanApplicationBackofficeAPIApiAssignLoanApplicationForBackofficeRequest {
    readonly id: string

    readonly assignLoanApplicationRequest: AssignLoanApplicationRequest
}

/**
 * Request parameters for declineLoanApplicationForBackoffice operation in LoanApplicationBackofficeAPIApi.
 */
export interface LoanApplicationBackofficeAPIApiDeclineLoanApplicationForBackofficeRequest {
    readonly id: string

    readonly finalDeclineLoanApplicationRequest: FinalDeclineLoanApplicationRequest
}

/**
 * Request parameters for findAllLoanApplicationsForBackoffice operation in LoanApplicationBackofficeAPIApi.
 */
export interface LoanApplicationBackofficeAPIApiFindAllLoanApplicationsForBackofficeRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>

    /**
     * Filter by loan application statuses
     */
    readonly filterStatuses?: Array<string>

    /**
     * Filter by assigned partner ID
     */
    readonly filterPartnerId?: string
}

/**
 * Request parameters for getLoanApplicationForBackoffice operation in LoanApplicationBackofficeAPIApi.
 */
export interface LoanApplicationBackofficeAPIApiGetLoanApplicationForBackofficeRequest {
    readonly id: string
}

/**
 * Request parameters for getMerchantSnapshotsForBackoffice operation in LoanApplicationBackofficeAPIApi.
 */
export interface LoanApplicationBackofficeAPIApiGetMerchantSnapshotsForBackofficeRequest {
    readonly id: string
}

/**
 * Request parameters for getTransactionsForBackoffice operation in LoanApplicationBackofficeAPIApi.
 */
export interface LoanApplicationBackofficeAPIApiGetTransactionsForBackofficeRequest {
    readonly id: string
}

/**
 * Request parameters for repaidLoanApplicationForBackoffice operation in LoanApplicationBackofficeAPIApi.
 */
export interface LoanApplicationBackofficeAPIApiRepaidLoanApplicationForBackofficeRequest {
    readonly id: string
}

/**
 * LoanApplicationBackofficeAPIApi - object-oriented interface
 */
export class LoanApplicationBackofficeAPIApi extends BaseAPI {
    /**
     * 
     * @summary Assign loan application to product
     * @param {LoanApplicationBackofficeAPIApiAssignLoanApplicationForBackofficeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public assignLoanApplicationForBackoffice(requestParameters: LoanApplicationBackofficeAPIApiAssignLoanApplicationForBackofficeRequest, options?: RawAxiosRequestConfig) {
        return LoanApplicationBackofficeAPIApiFp(this.configuration).assignLoanApplicationForBackoffice(requestParameters.id, requestParameters.assignLoanApplicationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Decline loan application
     * @param {LoanApplicationBackofficeAPIApiDeclineLoanApplicationForBackofficeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public declineLoanApplicationForBackoffice(requestParameters: LoanApplicationBackofficeAPIApiDeclineLoanApplicationForBackofficeRequest, options?: RawAxiosRequestConfig) {
        return LoanApplicationBackofficeAPIApiFp(this.configuration).declineLoanApplicationForBackoffice(requestParameters.id, requestParameters.finalDeclineLoanApplicationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export active loan applications to Excel
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public exportActiveLoanApplications(options?: RawAxiosRequestConfig) {
        return LoanApplicationBackofficeAPIApiFp(this.configuration).exportActiveLoanApplications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of loan applications
     * @param {LoanApplicationBackofficeAPIApiFindAllLoanApplicationsForBackofficeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllLoanApplicationsForBackoffice(requestParameters: LoanApplicationBackofficeAPIApiFindAllLoanApplicationsForBackofficeRequest = {}, options?: RawAxiosRequestConfig) {
        return LoanApplicationBackofficeAPIApiFp(this.configuration).findAllLoanApplicationsForBackoffice(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterStatuses, requestParameters.filterPartnerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get loan application by ID
     * @param {LoanApplicationBackofficeAPIApiGetLoanApplicationForBackofficeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLoanApplicationForBackoffice(requestParameters: LoanApplicationBackofficeAPIApiGetLoanApplicationForBackofficeRequest, options?: RawAxiosRequestConfig) {
        return LoanApplicationBackofficeAPIApiFp(this.configuration).getLoanApplicationForBackoffice(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get merchant snapshots for loan application
     * @param {LoanApplicationBackofficeAPIApiGetMerchantSnapshotsForBackofficeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMerchantSnapshotsForBackoffice(requestParameters: LoanApplicationBackofficeAPIApiGetMerchantSnapshotsForBackofficeRequest, options?: RawAxiosRequestConfig) {
        return LoanApplicationBackofficeAPIApiFp(this.configuration).getMerchantSnapshotsForBackoffice(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get transactions for loan application
     * @param {LoanApplicationBackofficeAPIApiGetTransactionsForBackofficeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTransactionsForBackoffice(requestParameters: LoanApplicationBackofficeAPIApiGetTransactionsForBackofficeRequest, options?: RawAxiosRequestConfig) {
        return LoanApplicationBackofficeAPIApiFp(this.configuration).getTransactionsForBackoffice(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark loan application as fully paid
     * @param {LoanApplicationBackofficeAPIApiRepaidLoanApplicationForBackofficeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public repaidLoanApplicationForBackoffice(requestParameters: LoanApplicationBackofficeAPIApiRepaidLoanApplicationForBackofficeRequest, options?: RawAxiosRequestConfig) {
        return LoanApplicationBackofficeAPIApiFp(this.configuration).repaidLoanApplicationForBackoffice(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LoanApplicationBorrowerAPIApi - axios parameter creator
 */
export const LoanApplicationBorrowerAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of loan applications
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllLoanApplicationsForBorrower: async (page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/borrower/loan-applications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get loan application by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanApplicationForBorrower: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLoanApplicationForBorrower', 'id', id)
            const localVarPath = `/api/borrower/loan-applications/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get transactions for loan application
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsForBorrower: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTransactionsForBorrower', 'id', id)
            const localVarPath = `/api/borrower/loan-applications/{id}/transactions`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LoanApplicationBorrowerAPIApi - functional programming interface
 */
export const LoanApplicationBorrowerAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LoanApplicationBorrowerAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return list of loan applications
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllLoanApplicationsForBorrower(page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageLoanApplicationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllLoanApplicationsForBorrower(page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApplicationBorrowerAPIApi.findAllLoanApplicationsForBorrower']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get loan application by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoanApplicationForBorrower(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoanApplicationForBorrower(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApplicationBorrowerAPIApi.getLoanApplicationForBorrower']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get transactions for loan application
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionsForBorrower(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TransactionDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionsForBorrower(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['LoanApplicationBorrowerAPIApi.getTransactionsForBorrower']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * LoanApplicationBorrowerAPIApi - factory interface
 */
export const LoanApplicationBorrowerAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LoanApplicationBorrowerAPIApiFp(configuration)
    return {
        /**
         * 
         * @summary Return list of loan applications
         * @param {LoanApplicationBorrowerAPIApiFindAllLoanApplicationsForBorrowerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllLoanApplicationsForBorrower(requestParameters: LoanApplicationBorrowerAPIApiFindAllLoanApplicationsForBorrowerRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageLoanApplicationDto> {
            return localVarFp.findAllLoanApplicationsForBorrower(requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get loan application by ID
         * @param {LoanApplicationBorrowerAPIApiGetLoanApplicationForBorrowerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoanApplicationForBorrower(requestParameters: LoanApplicationBorrowerAPIApiGetLoanApplicationForBorrowerRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoanApplicationDto> {
            return localVarFp.getLoanApplicationForBorrower(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get transactions for loan application
         * @param {LoanApplicationBorrowerAPIApiGetTransactionsForBorrowerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsForBorrower(requestParameters: LoanApplicationBorrowerAPIApiGetTransactionsForBorrowerRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TransactionDto>> {
            return localVarFp.getTransactionsForBorrower(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for findAllLoanApplicationsForBorrower operation in LoanApplicationBorrowerAPIApi.
 */
export interface LoanApplicationBorrowerAPIApiFindAllLoanApplicationsForBorrowerRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for getLoanApplicationForBorrower operation in LoanApplicationBorrowerAPIApi.
 */
export interface LoanApplicationBorrowerAPIApiGetLoanApplicationForBorrowerRequest {
    readonly id: string
}

/**
 * Request parameters for getTransactionsForBorrower operation in LoanApplicationBorrowerAPIApi.
 */
export interface LoanApplicationBorrowerAPIApiGetTransactionsForBorrowerRequest {
    readonly id: string
}

/**
 * LoanApplicationBorrowerAPIApi - object-oriented interface
 */
export class LoanApplicationBorrowerAPIApi extends BaseAPI {
    /**
     * 
     * @summary Return list of loan applications
     * @param {LoanApplicationBorrowerAPIApiFindAllLoanApplicationsForBorrowerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllLoanApplicationsForBorrower(requestParameters: LoanApplicationBorrowerAPIApiFindAllLoanApplicationsForBorrowerRequest = {}, options?: RawAxiosRequestConfig) {
        return LoanApplicationBorrowerAPIApiFp(this.configuration).findAllLoanApplicationsForBorrower(requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get loan application by ID
     * @param {LoanApplicationBorrowerAPIApiGetLoanApplicationForBorrowerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getLoanApplicationForBorrower(requestParameters: LoanApplicationBorrowerAPIApiGetLoanApplicationForBorrowerRequest, options?: RawAxiosRequestConfig) {
        return LoanApplicationBorrowerAPIApiFp(this.configuration).getLoanApplicationForBorrower(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get transactions for loan application
     * @param {LoanApplicationBorrowerAPIApiGetTransactionsForBorrowerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTransactionsForBorrower(requestParameters: LoanApplicationBorrowerAPIApiGetTransactionsForBorrowerRequest, options?: RawAxiosRequestConfig) {
        return LoanApplicationBorrowerAPIApiFp(this.configuration).getTransactionsForBorrower(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MerchantBackofficeAPIApi - axios parameter creator
 */
export const MerchantBackofficeAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of merchants
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllMerchantsForBackoffice: async (page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backoffice/merchants`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get merchant by ID with loan applications
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantForBackoffice: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMerchantForBackoffice', 'id', id)
            const localVarPath = `/api/backoffice/merchants/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MerchantBackofficeAPIApi - functional programming interface
 */
export const MerchantBackofficeAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MerchantBackofficeAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return list of merchants
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllMerchantsForBackoffice(page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageMerchantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllMerchantsForBackoffice(page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantBackofficeAPIApi.findAllMerchantsForBackoffice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get merchant by ID with loan applications
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMerchantForBackoffice(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MerchantDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMerchantForBackoffice(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MerchantBackofficeAPIApi.getMerchantForBackoffice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MerchantBackofficeAPIApi - factory interface
 */
export const MerchantBackofficeAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MerchantBackofficeAPIApiFp(configuration)
    return {
        /**
         * 
         * @summary Return list of merchants
         * @param {MerchantBackofficeAPIApiFindAllMerchantsForBackofficeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllMerchantsForBackoffice(requestParameters: MerchantBackofficeAPIApiFindAllMerchantsForBackofficeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageMerchantDto> {
            return localVarFp.findAllMerchantsForBackoffice(requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get merchant by ID with loan applications
         * @param {MerchantBackofficeAPIApiGetMerchantForBackofficeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMerchantForBackoffice(requestParameters: MerchantBackofficeAPIApiGetMerchantForBackofficeRequest, options?: RawAxiosRequestConfig): AxiosPromise<MerchantDto> {
            return localVarFp.getMerchantForBackoffice(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for findAllMerchantsForBackoffice operation in MerchantBackofficeAPIApi.
 */
export interface MerchantBackofficeAPIApiFindAllMerchantsForBackofficeRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for getMerchantForBackoffice operation in MerchantBackofficeAPIApi.
 */
export interface MerchantBackofficeAPIApiGetMerchantForBackofficeRequest {
    readonly id: string
}

/**
 * MerchantBackofficeAPIApi - object-oriented interface
 */
export class MerchantBackofficeAPIApi extends BaseAPI {
    /**
     * 
     * @summary Return list of merchants
     * @param {MerchantBackofficeAPIApiFindAllMerchantsForBackofficeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllMerchantsForBackoffice(requestParameters: MerchantBackofficeAPIApiFindAllMerchantsForBackofficeRequest = {}, options?: RawAxiosRequestConfig) {
        return MerchantBackofficeAPIApiFp(this.configuration).findAllMerchantsForBackoffice(requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get merchant by ID with loan applications
     * @param {MerchantBackofficeAPIApiGetMerchantForBackofficeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getMerchantForBackoffice(requestParameters: MerchantBackofficeAPIApiGetMerchantForBackofficeRequest, options?: RawAxiosRequestConfig) {
        return MerchantBackofficeAPIApiFp(this.configuration).getMerchantForBackoffice(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PartnerBackofficeAPIApi - axios parameter creator
 */
export const PartnerBackofficeAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create partner
         * @param {CreatePartnerRequest} createPartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerForBackoffice: async (createPartnerRequest: CreatePartnerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPartnerRequest' is not null or undefined
            assertParamExists('createPartnerForBackoffice', 'createPartnerRequest', createPartnerRequest)
            const localVarPath = `/api/backoffice/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPartnerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Return list of partners
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllPartnersForBackoffice: async (page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backoffice/partners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get partner by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerForBackoffice: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPartnerForBackoffice', 'id', id)
            const localVarPath = `/api/backoffice/partners/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update partner
         * @param {string} id 
         * @param {UpdatePartnerRequest} updatePartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartnerForBackoffice: async (id: string, updatePartnerRequest: UpdatePartnerRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePartnerForBackoffice', 'id', id)
            // verify required parameter 'updatePartnerRequest' is not null or undefined
            assertParamExists('updatePartnerForBackoffice', 'updatePartnerRequest', updatePartnerRequest)
            const localVarPath = `/api/backoffice/partners/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePartnerRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartnerBackofficeAPIApi - functional programming interface
 */
export const PartnerBackofficeAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PartnerBackofficeAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create partner
         * @param {CreatePartnerRequest} createPartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPartnerForBackoffice(createPartnerRequest: CreatePartnerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPartnerForBackoffice(createPartnerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnerBackofficeAPIApi.createPartnerForBackoffice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Return list of partners
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllPartnersForBackoffice(page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PagePartnerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllPartnersForBackoffice(page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnerBackofficeAPIApi.findAllPartnersForBackoffice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get partner by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPartnerForBackoffice(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPartnerForBackoffice(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnerBackofficeAPIApi.getPartnerForBackoffice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update partner
         * @param {string} id 
         * @param {UpdatePartnerRequest} updatePartnerRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePartnerForBackoffice(id: string, updatePartnerRequest: UpdatePartnerRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PartnerDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePartnerForBackoffice(id, updatePartnerRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PartnerBackofficeAPIApi.updatePartnerForBackoffice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PartnerBackofficeAPIApi - factory interface
 */
export const PartnerBackofficeAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PartnerBackofficeAPIApiFp(configuration)
    return {
        /**
         * 
         * @summary Create partner
         * @param {PartnerBackofficeAPIApiCreatePartnerForBackofficeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerForBackoffice(requestParameters: PartnerBackofficeAPIApiCreatePartnerForBackofficeRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartnerDto> {
            return localVarFp.createPartnerForBackoffice(requestParameters.createPartnerRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Return list of partners
         * @param {PartnerBackofficeAPIApiFindAllPartnersForBackofficeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllPartnersForBackoffice(requestParameters: PartnerBackofficeAPIApiFindAllPartnersForBackofficeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PagePartnerDto> {
            return localVarFp.findAllPartnersForBackoffice(requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get partner by ID
         * @param {PartnerBackofficeAPIApiGetPartnerForBackofficeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartnerForBackoffice(requestParameters: PartnerBackofficeAPIApiGetPartnerForBackofficeRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartnerDto> {
            return localVarFp.getPartnerForBackoffice(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update partner
         * @param {PartnerBackofficeAPIApiUpdatePartnerForBackofficeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePartnerForBackoffice(requestParameters: PartnerBackofficeAPIApiUpdatePartnerForBackofficeRequest, options?: RawAxiosRequestConfig): AxiosPromise<PartnerDto> {
            return localVarFp.updatePartnerForBackoffice(requestParameters.id, requestParameters.updatePartnerRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createPartnerForBackoffice operation in PartnerBackofficeAPIApi.
 */
export interface PartnerBackofficeAPIApiCreatePartnerForBackofficeRequest {
    readonly createPartnerRequest: CreatePartnerRequest
}

/**
 * Request parameters for findAllPartnersForBackoffice operation in PartnerBackofficeAPIApi.
 */
export interface PartnerBackofficeAPIApiFindAllPartnersForBackofficeRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for getPartnerForBackoffice operation in PartnerBackofficeAPIApi.
 */
export interface PartnerBackofficeAPIApiGetPartnerForBackofficeRequest {
    readonly id: string
}

/**
 * Request parameters for updatePartnerForBackoffice operation in PartnerBackofficeAPIApi.
 */
export interface PartnerBackofficeAPIApiUpdatePartnerForBackofficeRequest {
    readonly id: string

    readonly updatePartnerRequest: UpdatePartnerRequest
}

/**
 * PartnerBackofficeAPIApi - object-oriented interface
 */
export class PartnerBackofficeAPIApi extends BaseAPI {
    /**
     * 
     * @summary Create partner
     * @param {PartnerBackofficeAPIApiCreatePartnerForBackofficeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createPartnerForBackoffice(requestParameters: PartnerBackofficeAPIApiCreatePartnerForBackofficeRequest, options?: RawAxiosRequestConfig) {
        return PartnerBackofficeAPIApiFp(this.configuration).createPartnerForBackoffice(requestParameters.createPartnerRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Return list of partners
     * @param {PartnerBackofficeAPIApiFindAllPartnersForBackofficeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllPartnersForBackoffice(requestParameters: PartnerBackofficeAPIApiFindAllPartnersForBackofficeRequest = {}, options?: RawAxiosRequestConfig) {
        return PartnerBackofficeAPIApiFp(this.configuration).findAllPartnersForBackoffice(requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get partner by ID
     * @param {PartnerBackofficeAPIApiGetPartnerForBackofficeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getPartnerForBackoffice(requestParameters: PartnerBackofficeAPIApiGetPartnerForBackofficeRequest, options?: RawAxiosRequestConfig) {
        return PartnerBackofficeAPIApiFp(this.configuration).getPartnerForBackoffice(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update partner
     * @param {PartnerBackofficeAPIApiUpdatePartnerForBackofficeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updatePartnerForBackoffice(requestParameters: PartnerBackofficeAPIApiUpdatePartnerForBackofficeRequest, options?: RawAxiosRequestConfig) {
        return PartnerBackofficeAPIApiFp(this.configuration).updatePartnerForBackoffice(requestParameters.id, requestParameters.updatePartnerRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProcessDefinitionManagerApi - axios parameter creator
 */
export const ProcessDefinitionManagerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Starts a process instance of latest definition and return result at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
         * @summary Start a process instance with result in return
         * @param {string} key Process definition key
         * @param {{ [key: string]: any; }} variables Input variables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateGet: async (key: string, variables: { [key: string]: any; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('calculateGet', 'key', key)
            // verify required parameter 'variables' is not null or undefined
            assertParamExists('calculateGet', 'variables', variables)
            const localVarPath = `/api/process-definition/key/{key}/calculate`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            if (variables !== undefined) {
                for (const [key, value] of Object.entries(variables)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Starts a process instance of latest definition and return result at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
         * @summary Start a process instance with result in return
         * @param {string} key Process definition key
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculatePost: async (key: string, requestBody: { [key: string]: any; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('calculatePost', 'key', key)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('calculatePost', 'requestBody', requestBody)
            const localVarPath = `/api/process-definition/key/{key}/calculate`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List process definitions allowed to start by the user performed the request
         * @summary List process definitions allowed to start
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessDefinition: async (key: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getProcessDefinition', 'key', key)
            const localVarPath = `/api/process-definition/key/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form.
         * @summary Retrieve start form for the process
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStartForm: async (key: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getStartForm', 'key', key)
            const localVarPath = `/api/process-definition/key/{key}/start-form`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of start form variables of a latest process definition if allowed to access.
         * @summary Retrieve start form variables
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStartFormVariables: async (key: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getStartFormVariables', 'key', key)
            const localVarPath = `/api/process-definition/key/{key}/form-variables`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
         * @summary Retrieve start form for the process with form variables included
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStartFormWithData: async (key: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('getStartFormWithData', 'key', key)
            const localVarPath = `/api/process-definition/key/{key}/start-form-with-data`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List process definitions allowed to start by the user performed the request
         * @summary List process definitions allowed to start
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStartableByUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/process-definition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Starts a process instance of latest definition by form submission if allowed to access.
         * @summary Start a process instance by form submission
         * @param {string} key Process definition key
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitStartFrom: async (key: string, requestBody: { [key: string]: any; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('submitStartFrom', 'key', key)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('submitStartFrom', 'requestBody', requestBody)
            const localVarPath = `/api/process-definition/key/{key}/submit-form`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProcessDefinitionManagerApi - functional programming interface
 */
export const ProcessDefinitionManagerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProcessDefinitionManagerApiAxiosParamCreator(configuration)
    return {
        /**
         * Starts a process instance of latest definition and return result at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
         * @summary Start a process instance with result in return
         * @param {string} key Process definition key
         * @param {{ [key: string]: any; }} variables Input variables
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateGet(key: string, variables: { [key: string]: any; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateGet(key, variables, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessDefinitionManagerApi.calculateGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Starts a process instance of latest definition and return result at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
         * @summary Start a process instance with result in return
         * @param {string} key Process definition key
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculatePost(key: string, requestBody: { [key: string]: any; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculatePost(key, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessDefinitionManagerApi.calculatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List process definitions allowed to start by the user performed the request
         * @summary List process definitions allowed to start
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessDefinition(key: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessDefinitionRepresentation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessDefinition(key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessDefinitionManagerApi.getProcessDefinition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form.
         * @summary Retrieve start form for the process
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStartForm(key: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStartForm(key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessDefinitionManagerApi.getStartForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List of start form variables of a latest process definition if allowed to access.
         * @summary Retrieve start form variables
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStartFormVariables(key: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStartFormVariables(key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessDefinitionManagerApi.getStartFormVariables']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
         * @summary Retrieve start form for the process with form variables included
         * @param {string} key Process definition key
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStartFormWithData(key: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStartFormWithData(key, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessDefinitionManagerApi.getStartFormWithData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List process definitions allowed to start by the user performed the request
         * @summary List process definitions allowed to start
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStartableByUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProcessDefinitionRepresentation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStartableByUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessDefinitionManagerApi.listStartableByUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Starts a process instance of latest definition by form submission if allowed to access.
         * @summary Start a process instance by form submission
         * @param {string} key Process definition key
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitStartFrom(key: string, requestBody: { [key: string]: any; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TaskRepresentation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitStartFrom(key, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProcessDefinitionManagerApi.submitStartFrom']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProcessDefinitionManagerApi - factory interface
 */
export const ProcessDefinitionManagerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProcessDefinitionManagerApiFp(configuration)
    return {
        /**
         * Starts a process instance of latest definition and return result at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
         * @summary Start a process instance with result in return
         * @param {ProcessDefinitionManagerApiCalculateGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateGet(requestParameters: ProcessDefinitionManagerApiCalculateGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.calculateGet(requestParameters.key, requestParameters.variables, options).then((request) => request(axios, basePath));
        },
        /**
         * Starts a process instance of latest definition and return result at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
         * @summary Start a process instance with result in return
         * @param {ProcessDefinitionManagerApiCalculatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculatePost(requestParameters: ProcessDefinitionManagerApiCalculatePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.calculatePost(requestParameters.key, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * List process definitions allowed to start by the user performed the request
         * @summary List process definitions allowed to start
         * @param {ProcessDefinitionManagerApiGetProcessDefinitionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessDefinition(requestParameters: ProcessDefinitionManagerApiGetProcessDefinitionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ProcessDefinitionRepresentation> {
            return localVarFp.getProcessDefinition(requestParameters.key, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form.
         * @summary Retrieve start form for the process
         * @param {ProcessDefinitionManagerApiGetStartFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStartForm(requestParameters: ProcessDefinitionManagerApiGetStartFormRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getStartForm(requestParameters.key, options).then((request) => request(axios, basePath));
        },
        /**
         * List of start form variables of a latest process definition if allowed to access.
         * @summary Retrieve start form variables
         * @param {ProcessDefinitionManagerApiGetStartFormVariablesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStartFormVariables(requestParameters: ProcessDefinitionManagerApiGetStartFormVariablesRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getStartFormVariables(requestParameters.key, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
         * @summary Retrieve start form for the process with form variables included
         * @param {ProcessDefinitionManagerApiGetStartFormWithDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStartFormWithData(requestParameters: ProcessDefinitionManagerApiGetStartFormWithDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getStartFormWithData(requestParameters.key, options).then((request) => request(axios, basePath));
        },
        /**
         * List process definitions allowed to start by the user performed the request
         * @summary List process definitions allowed to start
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStartableByUser(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProcessDefinitionRepresentation>> {
            return localVarFp.listStartableByUser(options).then((request) => request(axios, basePath));
        },
        /**
         * Starts a process instance of latest definition by form submission if allowed to access.
         * @summary Start a process instance by form submission
         * @param {ProcessDefinitionManagerApiSubmitStartFromRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitStartFrom(requestParameters: ProcessDefinitionManagerApiSubmitStartFromRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TaskRepresentation>> {
            return localVarFp.submitStartFrom(requestParameters.key, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for calculateGet operation in ProcessDefinitionManagerApi.
 */
export interface ProcessDefinitionManagerApiCalculateGetRequest {
    /**
     * Process definition key
     */
    readonly key: string

    /**
     * Input variables
     */
    readonly variables: { [key: string]: any; }
}

/**
 * Request parameters for calculatePost operation in ProcessDefinitionManagerApi.
 */
export interface ProcessDefinitionManagerApiCalculatePostRequest {
    /**
     * Process definition key
     */
    readonly key: string

    readonly requestBody: { [key: string]: any; }
}

/**
 * Request parameters for getProcessDefinition operation in ProcessDefinitionManagerApi.
 */
export interface ProcessDefinitionManagerApiGetProcessDefinitionRequest {
    /**
     * Process definition key
     */
    readonly key: string
}

/**
 * Request parameters for getStartForm operation in ProcessDefinitionManagerApi.
 */
export interface ProcessDefinitionManagerApiGetStartFormRequest {
    /**
     * Process definition key
     */
    readonly key: string
}

/**
 * Request parameters for getStartFormVariables operation in ProcessDefinitionManagerApi.
 */
export interface ProcessDefinitionManagerApiGetStartFormVariablesRequest {
    /**
     * Process definition key
     */
    readonly key: string
}

/**
 * Request parameters for getStartFormWithData operation in ProcessDefinitionManagerApi.
 */
export interface ProcessDefinitionManagerApiGetStartFormWithDataRequest {
    /**
     * Process definition key
     */
    readonly key: string
}

/**
 * Request parameters for submitStartFrom operation in ProcessDefinitionManagerApi.
 */
export interface ProcessDefinitionManagerApiSubmitStartFromRequest {
    /**
     * Process definition key
     */
    readonly key: string

    readonly requestBody: { [key: string]: any; }
}

/**
 * ProcessDefinitionManagerApi - object-oriented interface
 */
export class ProcessDefinitionManagerApi extends BaseAPI {
    /**
     * Starts a process instance of latest definition and return result at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
     * @summary Start a process instance with result in return
     * @param {ProcessDefinitionManagerApiCalculateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public calculateGet(requestParameters: ProcessDefinitionManagerApiCalculateGetRequest, options?: RawAxiosRequestConfig) {
        return ProcessDefinitionManagerApiFp(this.configuration).calculateGet(requestParameters.key, requestParameters.variables, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Starts a process instance of latest definition and return result at first wait state. If allowed to access. The process definition has to have an extension: tag = calculator.
     * @summary Start a process instance with result in return
     * @param {ProcessDefinitionManagerApiCalculatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public calculatePost(requestParameters: ProcessDefinitionManagerApiCalculatePostRequest, options?: RawAxiosRequestConfig) {
        return ProcessDefinitionManagerApiFp(this.configuration).calculatePost(requestParameters.key, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List process definitions allowed to start by the user performed the request
     * @summary List process definitions allowed to start
     * @param {ProcessDefinitionManagerApiGetProcessDefinitionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessDefinition(requestParameters: ProcessDefinitionManagerApiGetProcessDefinitionRequest, options?: RawAxiosRequestConfig) {
        return ProcessDefinitionManagerApiFp(this.configuration).getProcessDefinition(requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form.
     * @summary Retrieve start form for the process
     * @param {ProcessDefinitionManagerApiGetStartFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getStartForm(requestParameters: ProcessDefinitionManagerApiGetStartFormRequest, options?: RawAxiosRequestConfig) {
        return ProcessDefinitionManagerApiFp(this.configuration).getStartForm(requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of start form variables of a latest process definition if allowed to access.
     * @summary Retrieve start form variables
     * @param {ProcessDefinitionManagerApiGetStartFormVariablesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getStartFormVariables(requestParameters: ProcessDefinitionManagerApiGetStartFormVariablesRequest, options?: RawAxiosRequestConfig) {
        return ProcessDefinitionManagerApiFp(this.configuration).getStartFormVariables(requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the process start form JSON description in FormIO format. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
     * @summary Retrieve start form for the process with form variables included
     * @param {ProcessDefinitionManagerApiGetStartFormWithDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getStartFormWithData(requestParameters: ProcessDefinitionManagerApiGetStartFormWithDataRequest, options?: RawAxiosRequestConfig) {
        return ProcessDefinitionManagerApiFp(this.configuration).getStartFormWithData(requestParameters.key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List process definitions allowed to start by the user performed the request
     * @summary List process definitions allowed to start
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listStartableByUser(options?: RawAxiosRequestConfig) {
        return ProcessDefinitionManagerApiFp(this.configuration).listStartableByUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Starts a process instance of latest definition by form submission if allowed to access.
     * @summary Start a process instance by form submission
     * @param {ProcessDefinitionManagerApiSubmitStartFromRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public submitStartFrom(requestParameters: ProcessDefinitionManagerApiSubmitStartFromRequest, options?: RawAxiosRequestConfig) {
        return ProcessDefinitionManagerApiFp(this.configuration).submitStartFrom(requestParameters.key, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TaskManagerApi - axios parameter creator
 */
export const TaskManagerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Assign the task to current user if available.
         * @summary Claim a task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claim: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('claim', 'id', id)
            const localVarPath = `/api/task/{id}/claim`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the task form JSON description in FormIO format. Embedded forms are expanded in single form.
         * @summary Retrieve form for the task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskForm: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTaskForm', 'id', id)
            const localVarPath = `/api/task/{id}/form`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List of task form variables of a latest process definition if allowed to access.
         * @summary Retrieve task form variables
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskFormVariables: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTaskFormVariables', 'id', id)
            const localVarPath = `/api/task/{id}/form-variables`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves the task form JSON description in FormIO format with form variales as submission/data. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
         * @summary Retrieve form with data for the task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskFormWithData: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTaskFormWithData', 'id', id)
            const localVarPath = `/api/task/{id}/form-with-data`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve brief info for a single task if available.
         * @summary Get task info
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskInfo: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTaskInfo', 'id', id)
            const localVarPath = `/api/task/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List tasks assigned to a user performed the request
         * @summary List assigned tasks
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAssigned: async (page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/task/assigned`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List unassigned tasks where the user is a candidate for execution according to their keycloak roles. 
         * @summary List tasks available for claim
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailable: async (page?: number, size?: number, sort?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/task/available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Complete the task by form submission if the user is assignee.
         * @summary Complete a task by form submission
         * @param {string} id Task id
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitForm: async (id: string, requestBody: { [key: string]: any; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('submitForm', 'id', id)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('submitForm', 'requestBody', requestBody)
            const localVarPath = `/api/task/{id}/submit-form`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unassign the task from current user.
         * @summary Unclaim a task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unclaim: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unclaim', 'id', id)
            const localVarPath = `/api/task/{id}/unclaim`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TaskManagerApi - functional programming interface
 */
export const TaskManagerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TaskManagerApiAxiosParamCreator(configuration)
    return {
        /**
         * Assign the task to current user if available.
         * @summary Claim a task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async claim(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.claim(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskManagerApi.claim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the task form JSON description in FormIO format. Embedded forms are expanded in single form.
         * @summary Retrieve form for the task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaskForm(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaskForm(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskManagerApi.getTaskForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List of task form variables of a latest process definition if allowed to access.
         * @summary Retrieve task form variables
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaskFormVariables(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaskFormVariables(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskManagerApi.getTaskFormVariables']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves the task form JSON description in FormIO format with form variales as submission/data. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
         * @summary Retrieve form with data for the task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaskFormWithData(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaskFormWithData(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskManagerApi.getTaskFormWithData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve brief info for a single task if available.
         * @summary Get task info
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTaskInfo(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TaskRepresentation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTaskInfo(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskManagerApi.getTaskInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List tasks assigned to a user performed the request
         * @summary List assigned tasks
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAssigned(page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageTaskRepresentation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAssigned(page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskManagerApi.listAssigned']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List unassigned tasks where the user is a candidate for execution according to their keycloak roles. 
         * @summary List tasks available for claim
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAvailable(page?: number, size?: number, sort?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageTaskRepresentation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAvailable(page, size, sort, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskManagerApi.listAvailable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Complete the task by form submission if the user is assignee.
         * @summary Complete a task by form submission
         * @param {string} id Task id
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async submitForm(id: string, requestBody: { [key: string]: any; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TaskRepresentation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.submitForm(id, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskManagerApi.submitForm']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unassign the task from current user.
         * @summary Unclaim a task
         * @param {string} id Task id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unclaim(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unclaim(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TaskManagerApi.unclaim']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TaskManagerApi - factory interface
 */
export const TaskManagerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TaskManagerApiFp(configuration)
    return {
        /**
         * Assign the task to current user if available.
         * @summary Claim a task
         * @param {TaskManagerApiClaimRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        claim(requestParameters: TaskManagerApiClaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.claim(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the task form JSON description in FormIO format. Embedded forms are expanded in single form.
         * @summary Retrieve form for the task
         * @param {TaskManagerApiGetTaskFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskForm(requestParameters: TaskManagerApiGetTaskFormRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getTaskForm(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * List of task form variables of a latest process definition if allowed to access.
         * @summary Retrieve task form variables
         * @param {TaskManagerApiGetTaskFormVariablesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskFormVariables(requestParameters: TaskManagerApiGetTaskFormVariablesRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getTaskFormVariables(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves the task form JSON description in FormIO format with form variales as submission/data. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
         * @summary Retrieve form with data for the task
         * @param {TaskManagerApiGetTaskFormWithDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskFormWithData(requestParameters: TaskManagerApiGetTaskFormWithDataRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getTaskFormWithData(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve brief info for a single task if available.
         * @summary Get task info
         * @param {TaskManagerApiGetTaskInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTaskInfo(requestParameters: TaskManagerApiGetTaskInfoRequest, options?: RawAxiosRequestConfig): AxiosPromise<TaskRepresentation> {
            return localVarFp.getTaskInfo(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * List tasks assigned to a user performed the request
         * @summary List assigned tasks
         * @param {TaskManagerApiListAssignedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAssigned(requestParameters: TaskManagerApiListAssignedRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageTaskRepresentation> {
            return localVarFp.listAssigned(requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * List unassigned tasks where the user is a candidate for execution according to their keycloak roles. 
         * @summary List tasks available for claim
         * @param {TaskManagerApiListAvailableRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAvailable(requestParameters: TaskManagerApiListAvailableRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageTaskRepresentation> {
            return localVarFp.listAvailable(requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(axios, basePath));
        },
        /**
         * Complete the task by form submission if the user is assignee.
         * @summary Complete a task by form submission
         * @param {TaskManagerApiSubmitFormRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        submitForm(requestParameters: TaskManagerApiSubmitFormRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<TaskRepresentation>> {
            return localVarFp.submitForm(requestParameters.id, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Unassign the task from current user.
         * @summary Unclaim a task
         * @param {TaskManagerApiUnclaimRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unclaim(requestParameters: TaskManagerApiUnclaimRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unclaim(requestParameters.id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for claim operation in TaskManagerApi.
 */
export interface TaskManagerApiClaimRequest {
    /**
     * Task id
     */
    readonly id: string
}

/**
 * Request parameters for getTaskForm operation in TaskManagerApi.
 */
export interface TaskManagerApiGetTaskFormRequest {
    /**
     * Task id
     */
    readonly id: string
}

/**
 * Request parameters for getTaskFormVariables operation in TaskManagerApi.
 */
export interface TaskManagerApiGetTaskFormVariablesRequest {
    /**
     * Task id
     */
    readonly id: string
}

/**
 * Request parameters for getTaskFormWithData operation in TaskManagerApi.
 */
export interface TaskManagerApiGetTaskFormWithDataRequest {
    /**
     * Task id
     */
    readonly id: string
}

/**
 * Request parameters for getTaskInfo operation in TaskManagerApi.
 */
export interface TaskManagerApiGetTaskInfoRequest {
    /**
     * Task id
     */
    readonly id: string
}

/**
 * Request parameters for listAssigned operation in TaskManagerApi.
 */
export interface TaskManagerApiListAssignedRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for listAvailable operation in TaskManagerApi.
 */
export interface TaskManagerApiListAvailableRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>
}

/**
 * Request parameters for submitForm operation in TaskManagerApi.
 */
export interface TaskManagerApiSubmitFormRequest {
    /**
     * Task id
     */
    readonly id: string

    readonly requestBody: { [key: string]: any; }
}

/**
 * Request parameters for unclaim operation in TaskManagerApi.
 */
export interface TaskManagerApiUnclaimRequest {
    /**
     * Task id
     */
    readonly id: string
}

/**
 * TaskManagerApi - object-oriented interface
 */
export class TaskManagerApi extends BaseAPI {
    /**
     * Assign the task to current user if available.
     * @summary Claim a task
     * @param {TaskManagerApiClaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public claim(requestParameters: TaskManagerApiClaimRequest, options?: RawAxiosRequestConfig) {
        return TaskManagerApiFp(this.configuration).claim(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the task form JSON description in FormIO format. Embedded forms are expanded in single form.
     * @summary Retrieve form for the task
     * @param {TaskManagerApiGetTaskFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTaskForm(requestParameters: TaskManagerApiGetTaskFormRequest, options?: RawAxiosRequestConfig) {
        return TaskManagerApiFp(this.configuration).getTaskForm(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List of task form variables of a latest process definition if allowed to access.
     * @summary Retrieve task form variables
     * @param {TaskManagerApiGetTaskFormVariablesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTaskFormVariables(requestParameters: TaskManagerApiGetTaskFormVariablesRequest, options?: RawAxiosRequestConfig) {
        return TaskManagerApiFp(this.configuration).getTaskFormVariables(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves the task form JSON description in FormIO format with form variales as submission/data. Embedded forms are expanded in single form. Form variables are included into the response in FormIO structure format.
     * @summary Retrieve form with data for the task
     * @param {TaskManagerApiGetTaskFormWithDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTaskFormWithData(requestParameters: TaskManagerApiGetTaskFormWithDataRequest, options?: RawAxiosRequestConfig) {
        return TaskManagerApiFp(this.configuration).getTaskFormWithData(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieve brief info for a single task if available.
     * @summary Get task info
     * @param {TaskManagerApiGetTaskInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTaskInfo(requestParameters: TaskManagerApiGetTaskInfoRequest, options?: RawAxiosRequestConfig) {
        return TaskManagerApiFp(this.configuration).getTaskInfo(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List tasks assigned to a user performed the request
     * @summary List assigned tasks
     * @param {TaskManagerApiListAssignedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAssigned(requestParameters: TaskManagerApiListAssignedRequest = {}, options?: RawAxiosRequestConfig) {
        return TaskManagerApiFp(this.configuration).listAssigned(requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List unassigned tasks where the user is a candidate for execution according to their keycloak roles. 
     * @summary List tasks available for claim
     * @param {TaskManagerApiListAvailableRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public listAvailable(requestParameters: TaskManagerApiListAvailableRequest = {}, options?: RawAxiosRequestConfig) {
        return TaskManagerApiFp(this.configuration).listAvailable(requestParameters.page, requestParameters.size, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Complete the task by form submission if the user is assignee.
     * @summary Complete a task by form submission
     * @param {TaskManagerApiSubmitFormRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public submitForm(requestParameters: TaskManagerApiSubmitFormRequest, options?: RawAxiosRequestConfig) {
        return TaskManagerApiFp(this.configuration).submitForm(requestParameters.id, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unassign the task from current user.
     * @summary Unclaim a task
     * @param {TaskManagerApiUnclaimRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unclaim(requestParameters: TaskManagerApiUnclaimRequest, options?: RawAxiosRequestConfig) {
        return TaskManagerApiFp(this.configuration).unclaim(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TestDataAPIApi - axios parameter creator
 */
export const TestDataAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create test loan application with test data
         * @param {string} merchantUserPhoneNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateTestLoanApplication: async (merchantUserPhoneNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'merchantUserPhoneNumber' is not null or undefined
            assertParamExists('initiateTestLoanApplication', 'merchantUserPhoneNumber', merchantUserPhoneNumber)
            const localVarPath = `/api/test-data/loan-applications/initiate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            if (merchantUserPhoneNumber !== undefined) {
                localVarQueryParameter['merchantUserPhoneNumber'] = merchantUserPhoneNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestDataAPIApi - functional programming interface
 */
export const TestDataAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestDataAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create test loan application with test data
         * @param {string} merchantUserPhoneNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initiateTestLoanApplication(merchantUserPhoneNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoanApplicationDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initiateTestLoanApplication(merchantUserPhoneNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestDataAPIApi.initiateTestLoanApplication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestDataAPIApi - factory interface
 */
export const TestDataAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestDataAPIApiFp(configuration)
    return {
        /**
         * 
         * @summary Create test loan application with test data
         * @param {TestDataAPIApiInitiateTestLoanApplicationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initiateTestLoanApplication(requestParameters: TestDataAPIApiInitiateTestLoanApplicationRequest, options?: RawAxiosRequestConfig): AxiosPromise<LoanApplicationDto> {
            return localVarFp.initiateTestLoanApplication(requestParameters.merchantUserPhoneNumber, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for initiateTestLoanApplication operation in TestDataAPIApi.
 */
export interface TestDataAPIApiInitiateTestLoanApplicationRequest {
    readonly merchantUserPhoneNumber: string
}

/**
 * TestDataAPIApi - object-oriented interface
 */
export class TestDataAPIApi extends BaseAPI {
    /**
     * 
     * @summary Create test loan application with test data
     * @param {TestDataAPIApiInitiateTestLoanApplicationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public initiateTestLoanApplication(requestParameters: TestDataAPIApiInitiateTestLoanApplicationRequest, options?: RawAxiosRequestConfig) {
        return TestDataAPIApiFp(this.configuration).initiateTestLoanApplication(requestParameters.merchantUserPhoneNumber, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TransactionBackofficeAPIApi - axios parameter creator
 */
export const TransactionBackofficeAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Return list of transactions
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [filterSearch] Search by loan application number, merchant name, partner number, partner ERP code, partner name (English and Arabic)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllTransactionsForBackoffice: async (page?: number, size?: number, sort?: Array<string>, filterSearch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backoffice/transactions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (filterSearch !== undefined) {
                localVarQueryParameter['filter.search'] = filterSearch;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Import transactions from XLS file
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importTransactionsForBackoffice: async (file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'file' is not null or undefined
            assertParamExists('importTransactionsForBackoffice', 'file', file)
            const localVarPath = `/api/backoffice/transactions/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TransactionBackofficeAPIApi - functional programming interface
 */
export const TransactionBackofficeAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TransactionBackofficeAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Return list of transactions
         * @param {number} [page] Zero-based page index (0..N)
         * @param {number} [size] The size of the page to be returned
         * @param {Array<string>} [sort] Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
         * @param {string} [filterSearch] Search by loan application number, merchant name, partner number, partner ERP code, partner name (English and Arabic)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findAllTransactionsForBackoffice(page?: number, size?: number, sort?: Array<string>, filterSearch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageTransactionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.findAllTransactionsForBackoffice(page, size, sort, filterSearch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionBackofficeAPIApi.findAllTransactionsForBackoffice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Import transactions from XLS file
         * @param {File} file 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importTransactionsForBackoffice(file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TransactionImportResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importTransactionsForBackoffice(file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TransactionBackofficeAPIApi.importTransactionsForBackoffice']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TransactionBackofficeAPIApi - factory interface
 */
export const TransactionBackofficeAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TransactionBackofficeAPIApiFp(configuration)
    return {
        /**
         * 
         * @summary Return list of transactions
         * @param {TransactionBackofficeAPIApiFindAllTransactionsForBackofficeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllTransactionsForBackoffice(requestParameters: TransactionBackofficeAPIApiFindAllTransactionsForBackofficeRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PageTransactionDto> {
            return localVarFp.findAllTransactionsForBackoffice(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterSearch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Import transactions from XLS file
         * @param {TransactionBackofficeAPIApiImportTransactionsForBackofficeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importTransactionsForBackoffice(requestParameters: TransactionBackofficeAPIApiImportTransactionsForBackofficeRequest, options?: RawAxiosRequestConfig): AxiosPromise<TransactionImportResult> {
            return localVarFp.importTransactionsForBackoffice(requestParameters.file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for findAllTransactionsForBackoffice operation in TransactionBackofficeAPIApi.
 */
export interface TransactionBackofficeAPIApiFindAllTransactionsForBackofficeRequest {
    /**
     * Zero-based page index (0..N)
     */
    readonly page?: number

    /**
     * The size of the page to be returned
     */
    readonly size?: number

    /**
     * Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported.
     */
    readonly sort?: Array<string>

    /**
     * Search by loan application number, merchant name, partner number, partner ERP code, partner name (English and Arabic)
     */
    readonly filterSearch?: string
}

/**
 * Request parameters for importTransactionsForBackoffice operation in TransactionBackofficeAPIApi.
 */
export interface TransactionBackofficeAPIApiImportTransactionsForBackofficeRequest {
    readonly file: File
}

/**
 * TransactionBackofficeAPIApi - object-oriented interface
 */
export class TransactionBackofficeAPIApi extends BaseAPI {
    /**
     * 
     * @summary Return list of transactions
     * @param {TransactionBackofficeAPIApiFindAllTransactionsForBackofficeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public findAllTransactionsForBackoffice(requestParameters: TransactionBackofficeAPIApiFindAllTransactionsForBackofficeRequest = {}, options?: RawAxiosRequestConfig) {
        return TransactionBackofficeAPIApiFp(this.configuration).findAllTransactionsForBackoffice(requestParameters.page, requestParameters.size, requestParameters.sort, requestParameters.filterSearch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Import transactions from XLS file
     * @param {TransactionBackofficeAPIApiImportTransactionsForBackofficeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public importTransactionsForBackoffice(requestParameters: TransactionBackofficeAPIApiImportTransactionsForBackofficeRequest, options?: RawAxiosRequestConfig) {
        return TransactionBackofficeAPIApiFp(this.configuration).importTransactionsForBackoffice(requestParameters.file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UISettingsApi - axios parameter creator
 */
export const UISettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUiSettingsForPortal: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ui-settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bo-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "bo-portal", [], configuration)

            // authentication agent-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "agent-portal", [], configuration)

            // authentication borrower-portal required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "borrower-portal", [], configuration)

            // authentication integration-client required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "integration-client", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UISettingsApi - functional programming interface
 */
export const UISettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UISettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUiSettingsForPortal(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UiConfigurations>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUiSettingsForPortal(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UISettingsApi.getUiSettingsForPortal']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UISettingsApi - factory interface
 */
export const UISettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UISettingsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUiSettingsForPortal(options?: RawAxiosRequestConfig): AxiosPromise<Array<UiConfigurations>> {
            return localVarFp.getUiSettingsForPortal(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UISettingsApi - object-oriented interface
 */
export class UISettingsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUiSettingsForPortal(options?: RawAxiosRequestConfig) {
        return UISettingsApiFp(this.configuration).getUiSettingsForPortal(options).then((request) => request(this.axios, this.basePath));
    }
}



